import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGridFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M3.5 11.5H3.25C1.73122 11.5 0.5 10.2688 0.5 8.75V3.25C0.5 1.73122 1.73122 0.5 3.25 0.5H3.5V11.5Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M8.75 0.5C10.1845 0.5 11.3609 1.59844 11.4873 3H5V0.5H8.75Z", fill: "currentColor" }),
        React.createElement("path", { d: "M11.5 4.5V7.5H5V4.5H11.5Z", fill: "currentColor" }),
        React.createElement("path", { d: "M11.4873 9C11.3609 10.4016 10.1845 11.5 8.75 11.5H5V9H11.4873Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectLayoutGridFill12.js.map